import { z } from 'zod';
export const AddUserPhoneNumberApiSchema = {
    params: z.object({ userId: z.string() }),
    body: z.object({ phoneNumber: z.string() }),
};
export const AddUserPhoneNumberRequestPathSchema = AddUserPhoneNumberApiSchema.params;
export const AddUserPhoneNumberRequestBodySchema = AddUserPhoneNumberApiSchema.body;
export const AddUserPhoneNumberRequestSchema = AddUserPhoneNumberApiSchema.params.merge(AddUserPhoneNumberApiSchema.body);
export const AddUserPhoneNumberResponseSchema = z.void();
